import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isConfigSet } from '@local/app-config';
import { useTrace } from '@local/web-design-system/dist/utils';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import { BENTLEY_SESSION_EXPIRED, LOGIN_ERROR_MESSAGES, NO_ACCESS, LOGIN_ALERT_SEVERITIES, LICENSE_GUARD_FAILURE, FIREWALL_GUARD_FAILURE, } from '../../constants';
import { getLoginError } from '../../store/localStorageHelpers/loginErrorHelper';
import { ERROR_NOTIFICATION_MESSAGE } from '../../strings';
export function LoginError({ helpSupportLink, }) {
    var _a, _b;
    const loginError = getLoginError();
    const applyTrace = useTrace('login-error');
    const customErrors = [
        NO_ACCESS,
        BENTLEY_SESSION_EXPIRED,
        LICENSE_GUARD_FAILURE,
        FIREWALL_GUARD_FAILURE,
    ];
    if (customErrors.includes(loginError)) {
        const errorMessage = (_a = LOGIN_ERROR_MESSAGES[loginError]) !== null && _a !== void 0 ? _a : ERROR_NOTIFICATION_MESSAGE.preLinkedText;
        const severity = (_b = LOGIN_ALERT_SEVERITIES[loginError]) !== null && _b !== void 0 ? _b : 'error';
        return (_jsx(Alert, { severity: severity, "automation-id": "login-error", sx: {
                alignItems: 'center',
            }, children: errorMessage }));
    }
    return loginError || !isConfigSet() ? (_jsx(Alert, { severity: "error", children: _jsxs("span", Object.assign({}, applyTrace('message'), { children: [ERROR_NOTIFICATION_MESSAGE.preLinkedText, _jsx(Link, { href: helpSupportLink !== null && helpSupportLink !== void 0 ? helpSupportLink : ERROR_NOTIFICATION_MESSAGE.href, target: "_blank", color: "inherit", rel: "noopener", underline: "always", children: ERROR_NOTIFICATION_MESSAGE.linkedText })] })) })) : null;
}
//# sourceMappingURL=LoginError.js.map